import { render, staticRenderFns } from "./CreateLogManagement.vue?vue&type=template&id=244d9f1e&"
import script from "./CreateLogManagement.vue?vue&type=script&lang=js&"
export * from "./CreateLogManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports